import { useCallback } from 'react'
import { ModalContainer } from '@components/Modals/ModalContainer'
import { IconButton, Stack, Text } from '@ui'
import { type BotData } from 'use-towns-client'
import { type Address } from 'viem'

import { BotInstallContent } from './BotInstallContent'

export interface InstallBotOnUserDialogProps {
    isOpen: boolean
    onClose: () => void
    bot: BotData
    walletAddress: Address
    onSuccess?: () => void
    isNavigating?: boolean
}

export const InstallBotOnUserDialog = ({
    isOpen,
    onClose,
    bot,
    walletAddress,
    onSuccess,
    isNavigating,
}: InstallBotOnUserDialogProps) => {
    const handleSuccess = useCallback(() => {
        onClose()
        onSuccess?.()
    }, [onClose, onSuccess])

    if (!isOpen) {
        return null
    }

    return (
        <ModalContainer padding="none" onHide={onClose}>
            <Stack gap="sm">
                <Stack
                    horizontal
                    alignItems="center"
                    justifyContent="center"
                    padding="lg"
                    position="relative"
                >
                    <Text fontWeight="strong" color="default">
                        Install Bot
                    </Text>
                    <IconButton
                        position="absolute"
                        style={{ right: '16px' }}
                        icon="close"
                        size="square_sm"
                        onClick={onClose}
                    />
                </Stack>
            </Stack>

            <BotInstallContent
                isCancellable
                appAddress={bot.appAddress}
                walletAddress={walletAddress}
                isExternalLoading={isNavigating}
                onCancel={onClose}
                onSuccess={handleSuccess}
            />
        </ModalContainer>
    )
}
